<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Random String Generator</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4>
            <v-text-field label="Min Length" type="number" min="1" :max="max" v-model="min"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field label="Max Length" type="number" :min="min" v-model="max"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field label="Number of strings" type="number" min="1" v-model="amount"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Pattern" v-model="pattern"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="generate()">Generate</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    pattern: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
    min: 5,
    max: 10,
    amount: 3,
    result: ''
  }),
  methods: {
    generate() {
      let strings = []
      const createString = () => {
        let result = ''
        const length =
          Math.floor(Math.random() * (this.max - this.min)) + this.min
        for (let i = 0; i < length; i++) {
          result += this.pattern.charAt(
            Math.floor(Math.random() * this.pattern.length)
          )
        }
        return result
      }
      for (let i = 0; i < this.amount; i++) {
        strings.push(createString())
      }
      this.result = strings.join('\n')
    }
  }
}
</script>

<style>
</style>